import { configureStore } from '@reduxjs/toolkit';
import authReducer from 'features/auth/authSlice';
import themeReducer from 'app/providers/themeSlice';
import uiReducer from 'app/providers/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
